<template>
  <div>
    <shipblu-table :hideHeader="true" :data="allSupplies" multiple v-model="selectedSupplies">
      <template slot="thead">
        <shipblu-th>{{$t('Supplies')}}: {{$t('Quantity')}}</shipblu-th>
        <shipblu-th>{{$t('Merchant Name')}}</shipblu-th>
        <shipblu-th>{{$t('Created On')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
        <shipblu-th v-if="$store.state.AppActiveUser.userRole !== 'finance'">
          <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5"/>
        </shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`">
          <shipblu-td :style="`color: ${getStyle(data[indextr])}`">
            <div v-for="item in data[indextr].supply_request_items.filter(item => item.count > 0)" :key="item.index">
              <span class="text-darkblue" v-if="item.package_size && item.package_size.short_code != 'OSZ'">{{item.package_size.short_code}}: {{item.count}}</span>
            </div>
          </shipblu-td>

          <shipblu-td :data="data[indextr].merchant">
            {{ data[indextr].merchant.name }} {{ data[indextr].merchant.display_name ? '- ' + data[indextr].merchant.display_name : '' }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].created">
            {{ new Date(data[indextr].created).toLocaleDateString('fr-CA') }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].status" :style="`color: ${getStyle(data[indextr])}`">
            <template>
              <vx-tooltip position="left" :text="data[indextr].supply_request_items.map(item => item.package_size && item.package_size.short_code != 'OSZ' ? `${item.package_size.short_code}: ${item.count_delivered}` : '').filter(element => element !== '').join('\n')">
                <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Status')}}</p>
                <div class="flex" style="width: fit-content;" @click="removeAttribute($event), openNotificationFailureData(data[indextr])">
                  <span class="capitalize border border-solid rounded-4xl px-5 py-1.5 leading-none sm:text-sm text-xs text-white" :style="`background-color: ${getStyle(data[indextr])}`">{{ data[indextr].status }}</span>
                </div>
              </vx-tooltip>
            </template>
          </shipblu-td>
          <shipblu-td v-if="$store.state.AppActiveUser.userRole !== 'finance'" class="order-2" style="vertical-align: middle;">
            <div class="md:text-center text-right" @click="removeAttribute($event)">
              <vs-dropdown
                vs-trigger-click
                @click="selectedSupplies = []"
                class="dd-actions cursor-pointer"
              >
                <span class="material-symbols-outlined text-2xl">more_horiz</span> 
                <vs-dropdown-menu style="width: 190px">
                  <vs-dropdown-item
                    :disabled="data[indextr].status === 'delivered' || data[indextr].status === 'delivery_attempted'"
                    @click="editQuantity(data[indextr])"
                  >
                    <span class="flex items-center">
                      <feather-icon
                        icon="CheckCircleIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('Actual Quantity')}}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="suppliesTotalRows" :currentPage="suppliesCurrentPage" @suppliesCurrentPage="currentPage = $event" />
  </div>
</template>

<script>
import common from '../../../assets/utils/common'
import ShipbluTable from '../../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../layouts/components/ShipBluTd.vue'
import ShipbluPagination from '../../../layouts/components/ShipbluPagination.vue'

export default {
  props: ['allSupplies', 'selected', 'suppliesTotalRows', 'suppliesCurrentPage'],
  data () {
    return {
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE
    }
  },
  computed: {
    selectedSupplies: {
      get () {
        return this.selected || []
      },
      set (val) {
        this.$emit('selected', val)
      }
    }
  },
  watch: {
    suppliesCurrentPage (val) {
      this.$emit('suppliesCurrentPage', val)
    }
  },
  methods: {
    removeAttribute (event) {
      event.preventDefault()
    },
    openNotificationFailureData (order) {
      common.openNotificationFailureData(this, order)
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getSupplyStatusColor (order) {
      return common.getOrderStatusColor(order.status)
    },
    editQuantity (supply) {
      this.$emit('supplyModal', true)
      this.$emit('supply', supply)
    }
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination
  }
}
</script>